import { useEffect, useState } from 'react';
import { Button } from '@artstorefronts/ui';

/**
 * One click, one finished string on the clipboard. Used for the `?wizard=` parameter and for
 * the scratch link builder's output, which is the whole point of both controls.
 */
export function CopyButton({
  value,
  label = 'Copy',
  ariaLabel,
  disabled = false,
}: {
  value: string;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch (error) {
      console.error('Could not copy to the clipboard:', error);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="shrink-0 font-normal"
      onClick={copy}
      disabled={disabled || !value}
      aria-label={ariaLabel}
    >
      {copied ? 'Copied' : label}
    </Button>
  );
}
